import React from 'react';
import heroImage from '../assets/images/leticia.png';
const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-image-bg"></div>
        <div className="hero-sparkle-effects"></div>
      </div>
      
      <div className="container">
        <div className="hero-content-wrapper">
          <div className="hero-image-left">
            <img 
              src={heroImage} 
              alt="Letícia Venâncio"
              className="hero-main-image"
            />
          </div>
          
          <div className="hero-course-title-mobile">CURSO Expert em Henna</div>
          
          <div className="hero-content">
            <h1 className="hero-title">
              MÉTODO ÚNICO E SIMPLES
              <br />
              PARA FAZER SOBRANCELHAS DE HENNA E TER AGENDA LOTADA.
            </h1>
            <p className="hero-subtitle">
            Descubra como profissionais de sobrancelhas estão elevando seus resultados e aumentando o faturamento com um método simples, técnico e comprovado para entregar Hennas realmente impecáveis.
            O mesmo passo a passo que me fez destravar a consistência dos resultados, fidelizar clientes e transformar a henna em um serviço valorizado, mesmo após anos enfrentando manchas, falhas e aplicações irregulares.
            </p>
            
            <div className="hero-video">
              <div className="video-player">
                <video
                  title="Vídeo do Método"
                  controls
                  className="video-iframe"
                  preload="metadata"
                  poster="/images/video-thumbnail.png"
                >
                  <source src="/videos/video.mp4" type="video/mp4" />
                  <source src="/video.mp4" type="video/mp4" />
                  Seu navegador não suporta o elemento de vídeo.
                </video>
              </div>
            </div>
          </div>

          <div className="pricing-info">
            <div className="old-price">de R$ 147,00 Por Apenas</div>
            <div className="installment">
              12X DE
              <br />
              <span className="installment-value">R$ 8,06</span>
            </div>
            <div className="cash-price">Ou R$ 77,90 á vista</div>
            <a href="https://pay.kiwify.com.br/TXv8v09" target="_blank" rel="noopener noreferrer" className="cta-button">
              Sim, quero começar agora!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

